export const AnimatedDisc = ({ animated }: { animated?: boolean }) => {
  return (
    <span className="relative mr-4 flex h-4 w-4">
      <span
        className={`absolute inline-flex h-full w-full rounded-full border-2 border-teal-500 bg-transparent ${
          animated ? 'animate-ping' : ''
        }`}
      />
      <span className="relative inline-flex h-full w-full rounded-full border-2 border-teal-500 bg-transparent" />
    </span>
  )
}
